import { useState } from "react";
import React from 'react'
import { motion } from "framer-motion";
import profile from "../../assets/profile3.jpg";
import Contact from "../Contact/contact";


export default function About() {
  const [isContactOpen, setContactOpen] = useState(false);
  
    const handleOpenContact = () => {
      setContactOpen(true);
    };
  
    const handleCloseContact = () => {
      setContactOpen(false);
    };
   return (
    <section id='About' className='px-4 sm:px-8 py-10 scroll-mt-24'>
      <div className='grid sm:grid-cols-2 gap-10 lg:gap-14 items-stretch'>
        {/* left column */}
        <motion.div
          className='flex justify-center'
          initial={{ opacity: 0, x: -28 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
        >
          <img
            src={profile}
            alt="Nidhi Shetty"
            className="w-full max-w-sm md:max-w-md rounded-2xl object-cover ring-2 ring-sky-400/25 ring-offset-4 ring-offset-[#0b0918] shadow-[0_24px_60px_-20px_rgba(56,189,248,0.18)]"
          />
        </motion.div>

        {/* right column */}
        <motion.div
          className='flex flex-col justify-between'
          initial={{ opacity: 0, x: 28 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
        >
          <div>
            <h1 className='text-3xl md:text-4xl font-bold mb-5 section-heading'>
              About Me
            </h1>

            <p className='text-slate-200/95 leading-relaxed mb-4 text-lg md:text-xl'>
              Hi, I’m Nidhi Shetty, a Front-End Developer with 3+ years of experience building responsive, user-friendly web applications. My interest in coding started in college, where I discovered the thrill of creating software that solves real problems.
            </p>

            <p className='text-slate-200/95 leading-relaxed mb-4 text-lg md:text-xl'>
              I’ve honed my skills in Angular, React, Next.js, and TypeScript across diverse projects. At Reliance Jio Platforms Ltd., I optimized dashboards and workflows. At Vosyn Technologies, I developed AI-driven products, multilingual video players, and reusable UI components that enhanced user experience.
            </p>

            <p className='text-slate-200/95 leading-relaxed text-lg md:text-xl'>
              I thrive on clean, efficient code and enjoy turning complex requirements into intuitive interfaces. Passionate about collaboration and innovation, I’m always excited to take on new challenges—let’s build something amazing together!
            </p>
          </div>
          <div className="flex flex-wrap gap-3 mt-8">
              <a
                href="/Nidhi Shetty_Software Engineer.pdf"
                download="Nidhi Shetty_Software Engineer"
                className="btn-accent-sky inline-block text-center"
              >
                Download Resume
              </a>
              <button
                type="button"
                onClick={handleOpenContact}
                className="btn-accent-violet"
              >
                Contact Me
              </button>
            </div>
        </motion.div>
        <Contact isOpen={isContactOpen} onClose={handleCloseContact} />
      </div>
    </section>
  )
}
